import React, { FunctionComponent, useMemo, useState } from "react"
import { get } from "../../store/data/actions"
import Loader from "../Loader/Loader"
import NoMoreLeft from "./NoMoreLeft"

export const withPackage = (
  Component: FunctionComponent,
  collection: string,
) => {
  const PackageWrap: FunctionComponent = () => {
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(false)

    useMemo(() => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      get<any>({ link: "/v1/check-package", query: { collection } })
        .then(() => {
          setLoading(false)
        })
        .catch((err) => {
          console.log(err)
          setLoading(false)
          setError(true)
        })
    }, [])

    return loading ? (
      <Loader />
    ) : error ? (
      <NoMoreLeft collection={collection} />
    ) : (
      <Component />
    )
  }
  return PackageWrap
}
